var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.3 49.4",
    style: {
      enableBackground: "new 0 0 53.3 49.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.6,17.4c0.1-0.8,0.2-1.5,0.2-2.3c0-8.3-6.7-15-15-15s-15,6.7-15,15c0,0.8,0.1,1.5,0.2,2.2C5.1,19.2,0,25.5,0,33    c0,9,7.3,16.4,16.4,16.4c3.9,0,7.5-1.4,10.3-3.6c2.8,2.3,6.4,3.6,10.3,3.6c9,0,16.4-7.3,16.4-16.4C53.3,25.6,48.4,19.4,41.6,17.4z     M13.8,15c0-7.2,5.8-13,13-13s13,5.8,13,13c0,0.6-0.1,1.3-0.2,1.9c-0.9-0.2-1.8-0.3-2.8-0.3c-3.9,0-7.5,1.4-10.3,3.6    c-2.8-2.3-6.4-3.6-10.3-3.6c-0.8,0-1.7,0.1-2.5,0.2C13.8,16.3,13.8,15.7,13.8,15z M30.8,33c0,3.9-1.6,7.5-4.1,10    c-2.5-2.6-4.1-6.1-4.1-10c0-1.2,0.2-2.4,0.4-3.5c1.2,0.3,2.5,0.5,3.8,0.5c1.2,0,2.4-0.2,3.5-0.4C30.6,30.7,30.8,31.9,30.8,33z     M26.8,28.1c-1.1,0-2.2-0.2-3.2-0.4c0.7-1.8,1.8-3.3,3.1-4.7c1.3,1.3,2.4,3,3.1,4.7C28.8,27.9,27.8,28.1,26.8,28.1z M21.7,27    c-3.5-1.5-6.2-4.5-7.4-8.2c0.7-0.1,1.4-0.2,2-0.2c3.3,0,6.3,1.1,8.8,3C23.7,23.2,22.5,25,21.7,27z M28.1,21.7c2.4-1.9,5.5-3,8.8-3    c0.8,0,1.6,0.1,2.4,0.2c-1.2,3.8-4,6.8-7.6,8.3C30.8,25.1,29.6,23.2,28.1,21.7z M2,33C2,26.5,6.4,21,12.4,19.2    c1.3,4.4,4.5,8,8.7,9.7c-0.3,1.3-0.5,2.7-0.5,4.1c0,4.4,1.8,8.4,4.6,11.4c-2.4,1.9-5.5,3-8.8,3C8.4,47.4,2,41,2,33z M36.9,47.4    c-3.3,0-6.3-1.1-8.8-3c2.9-2.9,4.6-7,4.6-11.4c0-1.4-0.2-2.7-0.5-4c4.3-1.7,7.6-5.3,9-9.7C47,21.1,51.3,26.6,51.3,33    C51.3,41,44.8,47.4,36.9,47.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelational);
export default __webpack_public_path__ + "static/media/relational.280f4ef6b0f0eb523ffbb85ce9b664b0.svg";
export { ForwardRef as ReactComponent };